

















































































import { Vue, Component } from "vue-property-decorator";
import Layout from "@/components/Layout.vue";
import TextField from "@/form/TextField.vue";
import AutoField from "@/form/AutoField.vue";
import DatepickerField from "@/form/DatepickerField.vue";
import Button from "@/form/Button.vue";
import ModalWithSaveAndCancel from "@/components/ModalWithSaveAndCancel.vue";
import { RoutePath } from "@/router/routePath";
import { PayToMandate } from "@/pages/maintenanceTypes";
import { toastErrorMessage, toastSuccessMessage } from "@/plugins/toasts";
import axios from "@/utils/ApiUtils";
import { nppCreateMandate } from "@/constants/apiconstants";
import { parseErrorMessage } from "@/utils/ErrorUtils";
import CurrencyField from "@/form/CurrencyField.vue";
import Footer from "@/components/Footer.vue";

@Component({
	components: {
		Footer,
		CurrencyField,
		ModalWithSaveAndCancel,
		Button,
		DatepickerField,
		TextField,
		Layout,
		AutoField,
	},
})
export default class AddPayToMandatePage extends Vue {
	private payToMandate: PayToMandate = {};
	private showCancelModal = false;
	private showSaveModal = false;
	private reportingCentreId = 0;

	beforeMount() {
		this.payToMandate = {};
		//Only RC ID is allowed
		if (this.$route.params.rcId.startsWith("R_")) {
			this.reportingCentreId = parseInt(
				this.$route.params.rcId.substr(2),
				10
			);
		}
	}

	onClickCancel(changed: boolean) {
		if (changed) {
			this.showCancelModal = true;
		} else {
			this.exit();
		}
	}

	closeModal() {
		this.showCancelModal = false;
		this.showSaveModal = false;
	}

	exit() {
		this.$router.push(RoutePath.PayToMandates);
	}

	onClickSave() {
		this.showSaveModal = true;
	}

	submit() {
		axios
			.post<string>(
				nppCreateMandate(this.reportingCentreId),
				this.payToMandate
			)
			.then(() => {
				toastSuccessMessage("PayTo agreement submitted successfully");
				this.$router.push(RoutePath.PayToMandates);
			})
			.catch((error) => {
				toastErrorMessage(parseErrorMessage(error));
			});
	}
}
